import type { Intervention } from '@seen/core/models/care-plans/intervention'
import { IconCircleCheck, IconCircleX, IconIntervention } from '@seen/ui'
import type { JSX } from 'react'
import { match } from 'ts-pattern'

export interface IconInterventionStatusProps {
  status: Intervention['status']
  className?: string
}

export function IconInterventionStatus({
  status,
  className,
}: IconInterventionStatusProps): JSX.Element {
  return match(status)
    .with('completed', () => <IconCircleCheck className={className} />)
    .with('revoked', () => <IconCircleX className={className} />)
    .with('entered-in-error', () => <IconCircleX className={className} />)
    .otherwise(() => <IconIntervention className={className} />)
}
